document.addEventListener('DOMContentLoaded', function () {
  // 1. Khai báo các biến
  const btn_show_brands = document.getElementById('HeaderDrawer-brands');
  const btn_show_submenu_brand = document.getElementById('link-brands');

  const btn_show_styles = document.getElementById('HeaderDrawer-styles');
  const show_submenu_style = document.getElementById('link-styles');

  const btn_show_collections = document.getElementById('HeaderDrawer-collections');
  const show_submenu_collections = document.getElementById('link-collections');

  // 2. Gán sự kiện cho Brands (Kiểm tra an toàn)
  if (btn_show_brands && btn_show_submenu_brand) {
    btn_show_brands.addEventListener('click', function () {
      btn_show_submenu_brand.classList.toggle('show');
    });
  }

  // 3. Gán sự kiện cho Styles (Kiểm tra an toàn)
  if (btn_show_styles && show_submenu_style) {
    btn_show_styles.addEventListener('click', function () {
      show_submenu_style.classList.toggle('show');
    });
  }

  // 4. Gán sự kiện cho Collections (Kiểm tra an toàn)
  if (btn_show_collections && show_submenu_collections) {
    btn_show_collections.addEventListener('click', function () {
      show_submenu_collections.classList.toggle('show');
    });
  } else {
    // Chỉ log lỗi này nếu thực sự trang đó CẦN có collections mà không thấy
    console.warn("Lưu ý: Không tìm thấy ID HeaderDrawer-collections hoặc link-collections trên trang này.");
  }
});